import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { routePaths } from "../../../common/infrastructure/routes/routePaths";

const GoogleOAuth: React.FC = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const studioId = searchParams.get("studioId");
    const sourceDomain = searchParams.get("sourceDomain");
    const returnUrl = searchParams.get("returnUrl");

    if (!studioId || !sourceDomain) {
      console.error("[OAuth] Missing required parameters:", {
        studioId,
        sourceDomain,
      });
      alert("Missing required information. Please try again.");
      window.history.back();
      return;
    }

    // Create state object for Google - store the FULL source URL, not just domain
    const stateData = {
      studioId: parseInt(studioId, 10),
      returnUrl: returnUrl || routePaths.portalAppointment, // Use provided returnUrl or fallback to /calendar
      sourceUrl: `${window.location.protocol}//${sourceDomain}`, // Full URL with protocol and port
      sourceDomain: sourceDomain, // Keep this for compatibility
      googleRedirectBaseUri: window.location.origin,
    };

    const state = btoa(JSON.stringify(stateData));

    // Build Google OAuth URL
    const googleParams = new URLSearchParams({
      client_id:
        "1087775957565-0d6enmsleci4brtpcme6hl4rtv4gclgn.apps.googleusercontent.com",
      redirect_uri: `${window.location.origin}/oauth/google/success`,
      response_type: "code",
      scope: "openid email profile",
      state: state,
      access_type: "online",
      prompt: "select_account",
    });

    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?${googleParams.toString()}`;

    window.location.replace(googleAuthUrl);
  }, [searchParams]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            width: "40px",
            height: "40px",
            border: "4px solid #f3f3f3",
            borderTop: "4px solid #3498db",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 20px",
          }}
        ></div>
        <p
          style={{
            color: "white",
          }}
        >
          Redirecting to Google...
        </p>
      </div>
    </div>
  );
};

export default GoogleOAuth;
